import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { TagColorVariant, TagComponent } from '@kaseya-design-components';
import { NavigationLinkComponent } from '@layout/navigation/components/navigation-link/navigation-link.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';

@Component({
  selector: 'itc-navigation-tagged-link',
  templateUrl: 'navigation-tagged-link.component.html',
  styleUrl: 'navigation-tagged-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [NavigationLinkComponent, TranslatePipe, TagComponent],
})
export class NavigationTaggedLinkComponent {
  readonly linkName = input.required<string>();
  readonly isTooltipEnabled = input.required<boolean>();
  readonly iconClass = input<string>();
  readonly id = input<string>();
  readonly tagTextTranslationKey = input<string>();
  readonly tagColorVariant = input<TagColorVariant>();
  readonly showIcon = input(true);
  readonly topNavigation = input<TopNavigationPath>();
}
